// HTTP Services
import WalletService from "services/http/endpoints/wallet";
import FinancialService from "services/http/endpoints/financial";
import { store } from "helpers/localStorage";

function useWallet() {
	async function fundWallet(amount: string | number) {
		const token = await WalletService.fundWallet(amount);
		WalletService.redirectBank(token);
	}

	async function buyGold(data: object) {
		const res = await FinancialService.buyGold(data);

		return res;
	}

	async function issueDiffAmount({ name, unit }: Wallet.IssueDiffAmount) {
		return await WalletService.issueDiffAmount({
			unit,
			name,
		});
	}

	async function cancelStock({
		amount,
		baseBaazarAmount,
	}: Financials.SellRequest): Promise<Financials.BuySellResult> {
		return await FinancialService.sellGold({ amount, baseBaazarAmount });
	}

	// TODO: should be refactored
	async function payFacilities(id: number | string): Promise<string> {
		const reports = "www.teste.com";
		//const res = await WalletService.payFacilities(id);
		store("callbackURI", reports);
		return reports;
		//return res;
	}
	return {
		buyGold,
		fundWallet,
		issueDiffAmount,
		cancelStock,
		payFacilities,
	};
}

export default useWallet;
